import { useState, useEffect } from 'react';
import { User, Session } from '@supabase/supabase-js';
import { supabase } from '@/integrations/supabase/client';

export function useAuth() {
  const [user, setUser] = useState<User | null>(null);
  const [session, setSession] = useState<Session | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    // Listener for auth state changes - set up BEFORE getSession
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (event, session) => {
        if (!isMounted) return;
        setSession(session);
        setUser(session?.user ?? null);
      }
    );

    const initAuth = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();

        if (session && isMounted) {
          setSession(session);
          setUser(session.user);
        }
        // No localStorage fallback - if no session, user must re-authenticate via token link
      } catch (error) {
        console.error('[useAuth] Error during initialization:', error);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    initAuth();

    return () => {
      isMounted = false;
      subscription.unsubscribe();
    };
  }, []);

  const signOut = async () => {
    if (session) {
      await supabase.auth.signOut();
    }
    
    window.location.href = '/auth';
  };

  // isAuthenticated depends on a REAL session only
  const isAuthenticated = !!session;

  return {
    user,
    session,
    loading,
    signOut,
    isAuthenticated
  };
}
